























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Modules
---------------------------------------- */

import kebabCase from 'lodash/kebabCase';


/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        content: Object
    },

    computed: {
        excerpt() {
            return this.content.excerpt[this.lang].substr(0, this.content.excerpt[this.lang].lastIndexOf(' ', 250) ) + '...';
        },

        slug() {
            return kebabCase(this.content.title[this.lang]);
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class NewsCard extends Vue {}

